export default __webpack_public_path__ + "static/media/transporte-colectivo.d33e4ef0.jpg";